import { useCallback, useMemo } from 'react';

import { detectIframe } from '../components/InitApp/HomeOwnerFlowDialog';
import { Codeowners } from '../consts/codeowners';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';
import { captureException } from '../utils/exception';

import { useOrgData } from './useOrgData';

export const useRedirectAfterConfirmation = () => {
  const { state, dispatch, actions } = useOnlineBookingReducer();
  const { token } = state;
  const { data } = useOrgData({ token });
  const isInIframeMode = useMemo(detectIframe, []);

  return {
    redirect: useCallback(() => {
      try {
        setTimeout(() => {
          if (!data?.redirectUrl) {
            dispatch(actions.setSuccess());
            return;
          }

          if (isInIframeMode) {
            // Handle redirect in iframe
            window.parent.postMessage({ type: 'hcp:redirect', url: data.redirectUrl }, '*');
          } else {
            // Handle redirect in browser tab
            window.location.assign(data.redirectUrl);
          }
        }, 100);
      } catch (error) {
        // Fallback to make sure we show at least the ThankYou page.
        // There may be cases where navigation is blocked by browser.
        captureException(error, Codeowners.CUSTOMER_INTAKE);
        dispatch(actions.setSuccess());
      }
    }, [data?.redirectUrl, actions, dispatch, isInIframeMode]),
    hasRedirectUrl: Boolean(data?.redirectUrl),
  };
};
